import { computed, defineComponent, h, useAttrs } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { VTab } from 'vuetify/components'

function isSameOrChildPath(currentPath, targetPath) {
  if (!targetPath || targetPath === '/') return currentPath === targetPath
  return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`)
}

export function normalizeTabStateAttrs(attrs = {}, active = false) {
  return {
    active,
    'aria-selected': active ? 'true' : 'false',
    class: [attrs.class, active ? 'v-tab--active' : 'v-tab--inactive']
  }
}

export default defineComponent({
  name: 'VTabCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()
    const route = useRoute()
    const router = useRouter()

    const routeActive = computed(() => {
      if (attrs.to == null) return false

      const resolved = router.resolve(attrs.to)
      return isSameOrChildPath(route.path, resolved.path)
    })

    return () =>
      h(
        VTab,
        {
          ...attrs,
          ...normalizeTabStateAttrs(attrs, routeActive.value)
        },
        slots
      )
  }
})
